<template>
    <transition name="dropdown">
        <div class="dropdown-filter">
            <div class="row no-gutters" v-if="hasSelection">
                <div class="alink mr-1" v-if="filter.vector" @click="onRemove('vector')">
                    <span class="mr-2">VETTORE</span><b>{{filter.vector.objA}}</b>
                </div>
                <div class="alink" v-if="!isFullTimeOrario()" @click="onRemoveOrario">
                    <span class="mr-2">ORARIO</span><b>{{orario}}</b>
                </div>
                <div class="alink" v-if="filter.scalo" @click="onRemove('scalo')">
                    <span class="mr-2">SCALO</span><b>{{scali[filter.scalo-1]}}</b>
                </div>
                <div class="alink mr-1" v-if="filter.partenza" @click="onRemove('partenza')">
                    <span class="mr-2">PARTENZA</span><b>{{filter.partenza.label}}</b>
                </div>
                <div class="alink" v-if="filter.atterraggio" @click="onRemove('atterraggio')">
                    <span class="mr-2">ATTERRAGGIO</span><b>{{filter.atterraggio.label}}</b>
                </div>
            </div>
            <div class="bg-white">
                <form>
                    <div class="form-group">
                        <label>Vettore</label>
                        <div class="row no-gutters pl-3 py-2 pl-md-5 py-md-3 bg-light" :style="isMobile? 'max-height: 160px; overflow: auto' : ''">
                            <div v-for="(item, index) in vectors" :key="index" class="col-12 col-md-4">
                                <div class="pretty p-default p-curve">
                                    <input type="radio" name="vector" :checked="isCheckedVector(item)" @click="onSelect('vector', item)"/>
                                    <div class="state p-secondary-o">
                                        <label>{{item.objA}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Orario di partenza</label>
                        <div class="row no-gutters pl-3 pl-md-5 py-3 bg-light">
                            <div class="col-12">
                                <TimeRangeSlider :value="filter.orario" @input="onInputOrario"/>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Scali</label>
                        <div class="row no-gutters pl-2 pl-md-5 py-3 bg-light">
                            <div v-for="(item, index) in scali" :key="index" class="col-12 col-md-4">
                                <div class="pretty p-default p-curve">
                                    <input type="radio" name="scalo" :checked="isCheckedScalo(index+1)" @click="onSelect('scalo', index+1)"/>
                                    <div class="state p-secondary-o">
                                        <label>{{item}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import TimeRangeSlider from '../../../common/TimeRangeSlider'
import {isFullTimeOrario} from '../../../../../utils/helper'
import {simpleTimeFormatterObj} from '../../../../../utils/formatter'
import {makeEmptyOrario} from '../../../../../store/modules/itinerario/actions/utils'
import MobileDetector from '../../../../common/MobileDetector'

export default {
  name: 'DropdownFilterFlight',
  mixins: [MobileDetector],
  components: {TimeRangeSlider},
  props: {
    value: Object,
    isFrom: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    list: function () {
      return this.getTypesAereoporti().map(function (item) {
        return {label: item.name, value: item.id}
      })
    },
    vectors: function () {
      return this.getVectors().sort((a, b) => {
        return ('' + a.objA).localeCompare(b.objA)
      })
    },
    filter: function () {
      return this.value
    },
    hasSelection: function () {
      return this.filter.vector || this.filter.scalo || !isFullTimeOrario(this.filter.orario) || this.filter.partenza || this.filter.atterraggio
    },
    scali: function () {
      return ['Zero Scali', '1 Scalo', '2 Scali']
    },
    orario: function () {
      return simpleTimeFormatterObj(this.filter.orario[0]) + ' - ' + simpleTimeFormatterObj(this.filter.orario[1])
    }
  },
  methods: {
    ...mapGetters(['getTypesAereoporti', 'getFlightVectorsFrom', 'getFlightVectorsTo']),
    getVectors: function () {
      return this.isFrom ? this.getFlightVectorsFrom() : this.getFlightVectorsTo()
    },
    isFullTimeOrario: function () {
      return isFullTimeOrario(this.filter.orario)
    },
    onSelect: function (property, item) {
      this.filter[property] = item
      this.$emit('change', this.filter)
    },
    onInputOrario: function (item) {
      this.filter.orario = item
      this.$emit('change', this.filter)
    },
    onSelectPartenza: function (item) {
      this.filter.partenza = item
      this.$emit('change', this.filter)
    },
    onSelectAtterraggio: function (item) {
      this.filter.atterraggio = item
      this.$emit('change', this.filter)
    },
    onRemove: function (property) {
      this.filter[property] = null
      this.$emit('change', this.filter)
    },
    onRemoveOrario: function () {
      this.filter.orario = makeEmptyOrario()
      this.$emit('change', this.filter)
    },
    isCheckedVector: function (item) {
      return this.filter.vector ? this.filter.vector.objB === item.objB : false
    },
    isCheckedScalo: function (item) {
      return this.filter.scalo === item
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/dropdown/DropdownFilterFlight.vue